import mutations from "./mutations";

const state = {
  queue: []
};

export default {
  state,
  mutations
};
